import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './auth.js';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import './index.css';
import './globals.css';
import './App.css';

msalInstance.initialize().then(async () => {

  const redirectResult = await msalInstance.handleRedirectPromise();
  if (redirectResult?.account) {
    msalInstance.setActiveAccount(redirectResult.account);
  }

  const existing = msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];
  if (!existing) {
    msalInstance.loginRedirect({scopes: ["User.Read"]});
    return;
  }

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
});
